function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Duur-contract",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "calendar-clock",
  transform: "translate(2.000000, 1.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.75,27.75 L2.75,27.75 C1.36928813,27.75 0.25,26.6307119 0.25,25.25 L0.25,5.25 C0.25,3.86928813 1.36928813,2.75 2.75,2.75 L25.25,2.75 C26.6307119,2.75 27.75,3.86928813 27.75,5.25 L27.75,12.75",
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.25,
  y1: 10.25,
  x2: 27.75,
  y2: 10.25,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 7.75,
  y1: 5.25,
  x2: 7.75,
  y2: 0.25,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("line", {
  x1: 20.25,
  y1: 5.25,
  x2: 20.25,
  y2: 0.25,
  id: "Path",
  stroke: "#485156"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#425CD4",
  cx: 27.75,
  cy: 27.75,
  r: 10
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#425CD4",
  points: "32.17 27.75 27.75 27.75 27.75 23.3316667"
})));
function SvgDuurcontract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Duur contract") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuurcontract);
export default __webpack_public_path__ + "static/media/Duur contract.5e43003a5074d6430c4e71766f708a33.svg";
export { ForwardRef as ReactComponent };